module.exports = __webpack_public_path__ + "img/EKI_MARCHE_en.31b1b4a9.jpg";